// Column-shape helpers shared by the grid head, body cells and total row so
// that a column's alignment is decided in exactly one place.

// Cell types whose rendered value is a figure meant to be compared down the
// column. Right-aligning these lines up the decimal points.
export const NUMERIC_CELLS = new Set([
    'Amount',
    'Balance',
    'CryptoAmount',
    'Percent',
    'Number'
]);

/**
 * True when a column should be right-aligned. Derived from the cell type so a
 * new grid gets it for free; `alignRight: true` stays available as an explicit
 * override for columns the cell type can't classify.
 */
export const isNumericColumn = (field) =>
    !!field && (field.alignRight === true || NUMERIC_CELLS.has(field.cell));

/** Alignment for a column, in the form TableCell's `align` prop expects. */
export const columnAlign = (field) => (isNumericColumn(field) ? 'right' : 'left');

// Markers the column layout code (resize, reorder) finds service cells by,
// rather than by position: `:last-of-type` also hits the no-results row.

/** Attribute on every cell of the pinned row-actions column. */
export const GRID_ACTIONS_CELL_ATTR = 'data-grid-actions';

/** Props to spread on a row-actions cell: `<TableCell {...GRID_ACTIONS_CELL_PROPS}>`. */
export const GRID_ACTIONS_CELL_PROPS = { [GRID_ACTIONS_CELL_ATTR]: true };

/**
 * Class of the box a text cell caps its width with while the table keeps its
 * natural widths; once the user sizes the columns the cap is lifted and the
 * text fills the column (see gridColumnSizing.styles.js).
 */
export const GRID_TEXT_CLAMP_CLASS = 'grid-text-clamp';
